import { GeoJsonLayer } from "@deck.gl/layers";
import { CompositeLayer } from "@deck.gl/core";
import type { CompositeLayerProps } from "@deck.gl/core/lib/composite-layer";
import area from "@turf/area";
import union from "@turf/union";
import { feature, geometryCollection, Polygon } from "@turf/helpers";
import { SELECTED_TITLE_FILL_COLOR, SELECTED_TITLE_LINE_COLOR } from "../../util";
import type { Geometry } from "../../typings";
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import { MaskExtension } from "@deck.gl/extensions";
import { getPermissions, hasBetaFeature } from "src/js/stores/user/actions";
import { Feature } from "src/js/stores/user";

export interface SelectedTitleLayerProps extends CompositeLayerProps<unknown> {
  parcelSizeMin: number;
  parcelSizeMax: number;
  selection: Geometry[];
}

export class SelectedTitleLayer extends CompositeLayer<unknown, SelectedTitleLayerProps> {
  static componentName = "SelectedTitleLayer";

  renderLayers() {
    const geofenceGeometries = getPermissions()?.geofencesGeometries;
    const maskExtensions = [] as any[];
    let maskId: string | undefined;

    if (geofenceGeometries?.length && !hasBetaFeature(Feature.disableGeofence)) {
      maskExtensions.push(new MaskExtension());
      maskId = "Geofence";
    }
    const { selection, parcelSizeMin, parcelSizeMax } = this.props;

    const filteredPolygons = selection.filter((polygon) => {
      const polygonArea = area(polygon);
      return polygonArea > parcelSizeMin && polygonArea < parcelSizeMax;
    });

    if (!filteredPolygons.length) return [];

    const fillPolygon = union(...filteredPolygons.map((p) => feature(p as Polygon)));

    return [
      new GeoJsonLayer({
        ...this.getSubLayerProps({ id: "fill" }),
        extensions: maskExtensions,
        maskId,
        data: fillPolygon,
        stroked: false,
        filled: true,
        getFillColor: SELECTED_TITLE_FILL_COLOR,
      }),
      new GeoJsonLayer({
        ...this.getSubLayerProps({ id: "outline" }),
        extensions: maskExtensions,
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        //@ts-ignore
        maskId,
        data: geometryCollection(filteredPolygons),
        stroked: true,
        lineWidthUnits: "pixels",
        getLineWidth: 4,
        getLineColor: SELECTED_TITLE_LINE_COLOR,
        filled: false,
      }),
    ];
  }
}
